// Generated by BUCKLESCRIPT VERSION 2.0.0, PLEASE EDIT WITH CARE
'use strict';

var Src1  = require("./images/1.gif");
var Src2  = require("./images/2.jpg");
var Src4  = require("./images/4.gif");
var Src5  = require("./images/5.jpg");
var Src6  = require("./images/6.jpg");
var Src7  = require("./images/7.jpg");
var Src8  = require("./images/8.jpg");
var Src9  = require("./images/9.jpg");
var Src10 = require("./images/10.jpg");

var data = /* array */[
  /* record */[
    /* src */Src1,
    /* origin */"http://memory-dealer.tumblr.com/post/159603930761/e-n-t-r-o-p-y",
    /* author */"Memory Dealer"
  ],
  /* record */[
    /* src */Src2,
    /* origin */"https://www.pinterest.ca/pin/355714070559138155/",
    /* author */"Aaron Smith"
  ],
  /* record */[
    /* src */Src4,
    /* origin */"http://30000fps.com/post/158237586643",
    /* author */"30000fps"
  ],
  /* record */[
    /* src */Src5,
    /* origin */"http://magastrom.tumblr.com/post/140564618950",
    /* author */"Magnus \xc3\x85str\xc3\xb6m"
  ],
  /* record */[
    /* src */Src6,
    /* origin */"http://nicolereber.tumblr.com/post/112994588207",
    /* author */"Nicolerber"
  ],
  /* record */[
    /* src */Src7,
    /* origin */"http://design-milk.com/stone-fields-by-giuseppe-randazzo/",
    /* author */"Giuseppe Randazzo"
  ],
  /* record */[
    /* src */Src8,
    /* origin */"http://kevc.tumblr.com/post/159115819074",
    /* author */"Kevc"
  ],
  /* record */[
    /* src */Src9,
    /* origin */"https://www.theghostlystore.com/collections/art/products/michael-cina-biolumin-v-1#prettyPhoto",
    /* author */"Michael Cina"
  ],
  /* record */[
    /* src */Src10,
    /* origin */"http://www.mariasvarbova.com/swimmingpool-gnkl",
    /* author */"Maria Svarbova"
  ]
];

exports.data = data;
/* data Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/Images.re
// module id = 44
// module chunks = 0